"use client";

import { Link } from "@/app/components/lib/navigation/Link";
import { useTranslation } from "@/hooks/localization/useTranslations";
import { PagesPaths } from "@/utils/functions/pages-paths";

interface props {
  clearFilterText: string;
  filterValue: string;
}

const ClearFilter: React.FC<props> = ({ clearFilterText, filterValue }) => {
  const t = useTranslation();

  return (
    <div className="clear-filter">
      <div className="text">
        <span> {clearFilterText}</span>
        <span className="filter-name">{filterValue}</span>
      </div>
      <Link prefetch={false} href={PagesPaths.blog}>
        <span className="clear-filter-btn">{t.clear_filter}</span>
      </Link>
    </div>
  );
};

export default ClearFilter;
